import getStringAfterFirstDot from './get-string-after-first-dot';
const buildField = field => {
  const [mainField] = field.split('.');
  const nestedFields = getStringAfterFirstDot(field);
  if (nestedFields && nestedFields.length) return `${mainField} { ${buildField(nestedFields)} }`;
  return mainField;
};
const buildEntityQueryFields = keys => {
  if (!keys || !keys.length) return '';
  return keys.map(buildField).join(', ');
};
export default buildEntityQueryFields;
//# sourceMappingURL=build-entity-query-fields.js.map